import React, { useEffect, useState } from "react";
import { CiCalendarDate, CiShoppingTag, CiUser } from "react-icons/ci";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import Utils from "../utils/utils";

const LectureCard = ({
  role,
  lecture,
  index,
  onclickOpenLecture,
  activeButton,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const getLectureStatus = (lecture) => {
    const lectureTime = lecture.lectureTime;
    const joiningLink = lecture.joiningLink;
    const videoLink = lecture.videoLink;
    let originalLectureTime = new Date(lectureTime);
    let currentTime = new Date(new Date().toUTCString());
    if (lecture.lectureEndTime) {
      let t = new Date(lecture.lectureEndTime);
      if (currentTime > t && videoLink === "false") {
        return "SESSION ENDED";
      }
    }

    if (currentTime >= originalLectureTime) {
      if (videoLink && videoLink !== "false") {
        return "VIEW RECORDING";
      } else if (joiningLink) {
        return "JOIN LECTURE";
      } else {
        return null;
      }
    } else {
      return "NOT STARTED";
    }
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className={`mt-2 max-w-[100%] w-full transition-transform duration-700 ease-in-out transform `}
    >
      <div
        bkl="LectureCard"
        className={`card p-4 text-sm shadow-sm border border-l-2 border-l-pink-700 h-auto  w-full max-w-full hover:shadow-lg  ${
          activeButton === "upComing" ? "cursor-not-allowed" : "cursor-pointer"
        }  ${
          isVisible
            ? "translate-x-0 opacity-100"
            : "translate-x-[-100%] opacity-0"
        }   `}
        key={`${lecture._id}-${index * index}`}
        onClick={onclickOpenLecture}
      >
        <div className="flex flex-row justify-between">
          <div className="flex flex-row items-center">
            <h3 className="text-lg font-semibold">{lecture.title}</h3>
            <span
              className={`text-sm uppercase ml-2 pl-3 pr-3 font-medium rounded-lg ${
                lecture.lectureMode === "Live"
                  ? "bg-[#eefcff] text-[#049402]"
                  : "bg-[#FAF5FF] text-[#97266D]"
              }`}
            >
              {lecture.lectureMode}
            </span>
          </div>
        </div>

        <div className="mt-2 flex flex-col md:flex-row justify-between items-start">
          {/* Left Section: Instructor Details */}
          <div className="flex items-start w-full gap-3 py-1 text-[#544D4F] mb-4 md:mb-0  xs:flex-wrap ">
            <div className="flex items-center gap-1">
              <div
                className={`h-7 w-7 rounded-full flex items-center justify-center overflow-hidden ${
                  lecture.instructorName
                    ? Utils.getRandomBgColor() + " text-white"
                    : ""
                }`}
              >
                {lecture.instructorName ? (
                  Utils.getUserAvatar(lecture.instructorName)
                ) : (
                  <CiUser className="w-4 h-4" />
                )}
              </div>
              <div className="font-normal text-sm text-[#544D4F]">
                {lecture.instructorName}
              </div>
            </div>
            <div className="flex items-center gap-1">
              <div className="h-7 w-7 rounded-full flex justify-center items-center overflow-hidden">
                <CiCalendarDate className="w-4 h-4" />
              </div>
              <p className="font-normal text-sm">
                {Utils.formatDateTime(lecture.lectureTime)}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <div className="h-7 w-7 rounded-full flex justify-center items-center overflow-hidden">
                <CiShoppingTag className="w-4 h-4 transform scale-x-[-1]" />
              </div>
              <p className="font-normal text-sm">{lecture.category}</p>
            </div>
          </div>

          <div className="w-full md:w-auto flex justify-start">
            <button
              className={`rounded-lg px-4 py-2 whitespace-nowrap text-white bg-[#3470E4] hover:bg-blue-800 ${
                getLectureStatus(lecture) === "NOT STARTED" ||
                getLectureStatus(lecture) === "SESSION ENDED"
                  ? "cursor-not-allowed opacity-50"
                  : ""
              }`}
              disabled={
                getLectureStatus(lecture) === "NOT STARTED" ||
                getLectureStatus(lecture) === "SESSION ENDED"
              }
            >
              <span className="tracking-[1.25px]">
                {getLectureStatus(lecture)}
              </span>
            </button>
          </div>
        </div>

        {role && role.toLowerCase() === "admin" && (
          <div className="pt-3 flex overflow-hidden">
            {lecture.anyone ? (
              <div className="flex items-center gap-2">
                <button className="btn btn-xs uppercase shadow-inner text-white bg-pink-700 hover:bg-pink-800">
                  All
                  <IoIosCheckmarkCircleOutline className="w-5 h-5 font-extrabold" />
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                {lecture.batch.map((batch) => (
                  <span
                    className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                    key={batch}
                  >
                    {batch}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LectureCard;
